var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 60,
    viewBox: "0 0 113 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_720_4313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.337402 29.6901C0.337402 13.2927 13.6301 0 30.0275 0H82.8099C99.2072 0 112.5 13.2927 112.5 29.6901C112.5 46.0874 99.2072 59.3801 82.8098 59.3801H30.0274C13.6301 59.3801 0.337402 46.0874 0.337402 29.6901Z",
    fill: "url(#paint0_linear_720_4313)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.9507,
    y: 14.3335,
    width: 38.4871,
    height: 4.39853,
    rx: 2.19926,
    transform: "rotate(45 43.9507 14.3335)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2544,
    y: 41.7427,
    width: 38.4871,
    height: 4.39853,
    rx: 2.19926,
    transform: "rotate(-45 41.2544 41.7427)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_720_4313",
    x: -12.9839,
    y: -13.3213,
    width: 138.805,
    height: 86.0224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.66063
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_720_4313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_720_4313",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_4313",
    x1: 0.337402,
    y1: 29.6901,
    x2: 112.5,
    y2: 29.6901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE96FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.73cb7a79565ef4d90962a5fa0f08009f.svg";
export { ForwardRef as ReactComponent };